import { useAuth as useClerkAuth } from '@clerk/clerk-react'
import { LogOut } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import { performBackofficeLogout } from '../lib/entryContext'

/**
 * Shown when an account authenticates successfully but has no usable
 * backoffice surface (no company permissions, not admin, not courier).
 */
export default function BackofficeAccessDenied() {
  const { signOut } = useClerkAuth()
  const { workerOnly, role, companyName } = useAuth()

  const title = workerOnly
    ? 'No backoffice access'
    : 'No backoffice access'

  const message = workerOnly
    ? 'Your account is not linked to a company with backoffice permissions. If you are a field worker or courier without grants here, use the ComfortHub Field app instead.'
    : role === 'NONE'
      ? 'Your account is not linked to a company with backoffice permissions. If you are a worker or courier, use the ComfortHub Field app instead.'
      : 'You do not have permission to use the backoffice portal.'

  return (
    <div className="flex min-h-dvh items-center justify-center bg-gray-950 px-6 py-12 text-white">
      <div className="max-w-md text-center space-y-6">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-gradient-to-tr from-accent to-accent-strong flex items-center justify-center shadow-lg">
          <span className="font-bold text-lg">CH</span>
        </div>
        <div className="space-y-2">
          <h1 className="font-display text-2xl font-semibold tracking-tight">{title}</h1>
          <p className="text-sm text-zinc-400 leading-relaxed">{message}</p>
          {companyName && (
            <p className="text-xs text-zinc-500">Company: {companyName}</p>
          )}
        </div>
        <button
          type="button"
          onClick={() => performBackofficeLogout(signOut)}
          className="inline-flex items-center gap-2 rounded-xl bg-white/10 hover:bg-white/15 px-4 py-2.5 text-sm font-semibold transition-colors"
        >
          <LogOut size={16} />
          Log out
        </button>
      </div>
    </div>
  )
}
